module.exports = __webpack_public_path__ + "img/vehicleicon_paint.010f7072.jpg";